/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */
import { TrajksFormWrapper } from '../Trajks/TrajksFormWrapper';

const TRAJKS_COMPONENT_TYPE = 'TrajksModule' as const;

export type TrajksComponentType = typeof TRAJKS_COMPONENT_TYPE;

export interface ComponentsLookUpPayload {
  componentType: TrajksComponentType;
  id: string;
  title?: string;
  initialProps: unknown;
}

export const componentsLookUp = (
  payload: ComponentsLookUpPayload,
): React.ReactElement => {
  const { componentType } = payload;
  switch (componentType) {
    case TRAJKS_COMPONENT_TYPE:
      return <TrajksFormWrapper />;
    default:
      return null!;
  }
};
